import React from 'react';
import classnames from 'classnames';

import Button from '../components/Button';
import { makeBtStyles } from '../Theme';
import { useFindOrder } from './useFindOrder';
import { getReturnsCenterIdFromUrl } from '../ReturnsPageApp';


const useStyles = makeBtStyles( theme => ({
  form: {
    width: '500px'
  },
  heading: {
    ...theme.characteristicFont,
    fontSize: '21px',
    textAlign: 'center',
  },
  input: {
    width: '100%',
    marginBottom: '12px',
    borderRadius: '3px',
    fontSize: '14px',
    height: '40px',
    padding: '8px',
    border: '1px solid #DDDDDD',
    '&:focus': {
      outline: 'none',
      borderColor: theme.main.color,
    },
    '&.hasError': {
      borderColor: '#E73434',
    },
    '&::placeholder': {
      color: 'gray'
    },
    '&:-ms-input-placeholder': {
      color: 'gray'
    },
    '&::-ms-input-placeholder': {
      color: 'gray'
    }
  },
  button: {
    width: '100%',
    marginTop: '12px',
    fontSize: '16px'
  },
  error: {
    fontSize: '12px',
    color: '#E73434'
  }
}));


export default function FindOrderForm({ className='' }) {
  const classes = useStyles();
  const returnsCenterId = getReturnsCenterIdFromUrl();
  const { setField, form, findOrder, loading, error } = useFindOrder(returnsCenterId);

  const onFieldChange = (event:any) => {
    const { name, value } = event.target;
    setField({ name, value });
  }

  const submitDisabled = !form.order_number || !form.postal_code || loading;
  const onSubmit = (event:any) => {
    event.preventDefault();
    findOrder(form);
  };

  return <form onSubmit={onSubmit} className={classnames(classes.form,className)}>
    <h2 className={classes.heading}>Start Your Return</h2>
    <div>
      <input
        id="return-order-number"
        type="text"
        placeholder="Order Number"
        value={form.order_number}
        name='order_number'
        onChange={onFieldChange}
        className={classes.input}
      />
    </div>
    <div>
      <input
        id="return-zip-code"
        type="text"
        placeholder="Zip Code"
        value={form.postal_code}
        name='postal_code'
        onChange={onFieldChange}
        className={classes.input}
      />
    </div>
    { !!error &&  
      <div className={classes.error}>
        {error}
      </div>
    }
    <Button type="submit" variant="primary" className={classes.button} disabled={submitDisabled}>
      { loading ? 'Looking Up Order' : 'Look Up Order' }
    </Button>
  </form>;
}